import { Routes } from '@angular/router';
import { PermissionsList } from '../../shared/common/PermissionList';
import { AuthorizationGuard } from '../../core/auth/guards/authorization.guard';


export const InvoicesRoutes: Routes = [
  {
    path: 'invoices',
    loadComponent: () => import('./pages/invoices/invoices.component').then(m => m.InvoicesPageComponent),
    title: 'Invoices | ADROIT',
    data: {
      animation: 'home',
      PermissionPageName: [
        PermissionsList[PermissionsList.ClientClientInvoicesView],
      ],
    },
    canActivate: [AuthorizationGuard],
  },
];
